import { APIConfig } from '../../types/definitions'
import { APIClient } from '../../infra/APIClient'
import { RoomDto, RoomConnectionDescriptorDto } from '../dtos/rooms'
import { CreateRoomPayload } from '../dtos/payloads'

export function createRoomsApi(opts: APIConfig): RoomsAPI {
  return new RoomsAPI(opts)
}

export class RoomsAPI extends APIClient {
  /**
   * Get a Room
   * @param id
   */
  get(id: string): Promise<RoomDto> {
    return this.client.get(`/v3/rooms/${id}`).then(this._data)
  }

  /**
   * Create a Room on-demand
   * @param payload
   */
  create(payload: CreateRoomPayload) {
    return this.client.post(`/v3/rooms`, payload).then(this._data)
  }

  /**
   * Get the connection info
   * to join a room
   * @param id
   */
  join(id: string): Promise<RoomConnectionDescriptorDto> {
    return this.client.get(`/v3/rooms/${id}/join`).then(this._data)
  }
}
